import React, {useCallback} from 'react';
import {MendelProvider as MendelWebClientProvider} from '@lookiero/mendel-web-client';
import {eventManager} from '@application/Event';
import {ExperimentEvent} from '@domain/model/Event';
import {useScope} from '../hooks/useScope';

interface MendelProviderProps {
  children: React.ReactNode;
}

const MendelProvider: React.FC<MendelProviderProps> = ({children}) => {
  const scope = useScope();

  const onAssigned = useCallback(({experimentName, variant}: {experimentName: string; variant: string}) => {
    eventManager.emit(ExperimentEvent.EXPERIMENT_APPLIED, {
      eventAction: variant,
      eventLabel: experimentName,
    });
  }, []);

  return (
    <MendelWebClientProvider apiHost="/mendel" userPrefix="web_" scope={scope} onAssigned={onAssigned}>
      {children}
    </MendelWebClientProvider>
  );
};

export {MendelProvider};
